/* eslint-disable */
<template>
  <div>
    <!-- Training Not found -->
    <v-card
        flat v-if="notFound && localShow"
        class="d-flex flex-column"
        style="background: transparent;"
        width="100vw"
        height="100vh"
    >
      <v-spacer/>
      <v-card tile width="55vw" height="25vh" class="d-flex flex-column mx-auto pa-10">
        <v-card-title class="justify-center">Not Found</v-card-title>
        <v-card-text>
          The selected training was not found. This error has been reported.
          Please return to Vizual Trainer to complete a different training assignment.
        </v-card-text>
        <v-spacer/>
        <v-card-actions>
          <v-btn block tile @click="closeOn404">Return to Vizual Trainer</v-btn>
        </v-card-actions>
        <v-spacer/>
      </v-card>
      <v-spacer/>
    </v-card>

    <!-- Training -->
    <v-card v-else-if="localShow" flat width="100vw" height="100vh" class="mx-auto">
      <v-card-title class="my-0 py-1 d-flex justify-center" style="line-height: 1;">
        {{ courseTitle }}
        <v-spacer/>
        <v-btn
            v-if="tableOfContents && tableOfContents.length > 1"
            icon
            @click="showTableOfContents = !showTableOfContents"
        >
          <v-icon>mdi-table-of-contents</v-icon>
        </v-btn>
      </v-card-title>
      <iframe
          :style="{
                    border: 0,
                    width: '100%',
                    height: '92%'
                  }"
          class="mt-4"
          ref="scormFrame"
          :src="source"
      />
    </v-card>
    <loading :show-loading="loading"/>

    <!-- Table Of Contents -->
    <v-dialog scrollable v-model="showTableOfContents" width="500">
      <v-card width="500" height="80vh" class="mx-auto">
        <v-card-title>Table Of Contents</v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item
                v-for="item in tableOfContents"
                :key="item.title"
                @click="setSource(item.content)"
            > {{ item.title }}
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars,no-unreachable */
import axios from "axios";
import Loading from "@/components/loading";

export default {
  name: "scormContent",
  components: {
    Loading
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    apiData: {
      type: Object,
      required: false,
      default() {
        return {}
      }
    },
    learner: {
      type: Object,
      required: false,
      default() {
        return {}
      }
    },
    status: {
      type: String,
      required: false,
      default: 'in-progress'
    },
    training: {
      type: String,
      required: false,
      default: ''
    },
    clientActive: {
      type: Boolean,
      required: false,
      default: false
    },
    externalCloseCommand: {
      type: Boolean,
      required: false,
      default: false
    },
    quizRecorded: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  computed: {},

  data: () => ({
    localShow: false,
    source: null,
    notFound: false,
    closeOnce: true,
    localStatus: null,
    loading: false,
    manifest: null,
    schema: '',
    courseTitle: '',
    tableOfContents: null,
    showTableOfContents: false,
    publicPath: 'http://localhost:8080',
    localStats: null,
    selectedSCO: '',
    // localStats: { // Need to pass this to the API per course per user and retrieve on course selection
    //   'cmi.mode': 'normal',                // 'browse', 'normal', 'review'
    //   'cmi.success_status': 'unknown',     // 'passed', 'failed', 'unknown'
    //   'cmi.completion_status': 'unknown',  // 'completed', 'incomplete', 'not attempted', 'unknown'
    //   'cmi.location': '',                  // characterstring (SPM: 1000)
    //   'cmi.suspend_data': ''               // characterstring (SPM: 64000)
    // }
    quizResults: {},
    interactionsCount: -1,
    commentsFromLearnerCount: -1,
    commentsFromLmsCount: -1,
    objectivesCount: -1,
    interactionObjectivesCount: -1,
    interactionsCorrectCount: -1,
  }),

  watch: {
    show(val) {
      this.localShow = val
      if (val) {
        this.init()
      }
    },

    externalCloseCommand(val) {
      // console.log('external close command')
      if (val) {
        this.closeScorm()
      }
    },

    quizRecorded(val) {
      if (val) {
        this.terminate('Quiz Recorded')
      }
    },
  },

  beforeMount() {
    this.buildScormAPIs()
  },

  mounted() {
    // console.log('mounted scorm content')
    this.$emit('send-handshake')
  },

  methods: {

    async init() {
      // console.log('api data', this.apiData)
      this.localStats = this.apiData ? this.apiData : {}
      this.localStatus = this.status ? this.status : 'in-progress'
      this.manifest = await this.buildSources()
      this.setSource()
    },

    /**
     * @description
     * Set IFrame source based on selected SCO. If the scorm training contains only a single SCO, that one is
     * chosen by default. If there are multiple, the table of contents is shown and the user may select an
     * assignment to complete.
     * @param selectedIndex
     */
    setSource(selectedIndex = null) {
      this.loading = true
      this.showTableOfContents = false
      let indexLocation = ''
      try {
        if (this.tableOfContents && this.tableOfContents.length > 0) {
          if (this.tableOfContents.length === 1) {
            const resource = this.manifest.getElementsByTagName('resource')[0]
            const href = resource.attributes.href.value
            const base = resource.attributes['xml:base']?.value || ''
            indexLocation = base + href
            // Apply progress to the correct object in this.localStats
            this.selectedSCO = this.tableOfContents[0].title
          } else if (!selectedIndex) {
            this.showTableOfContents = true
            this.loading = false
            return
          } else {
            const resources = this.manifest.getElementsByTagName('resource')
            for (let i = 0; i < resources.length; i++) {
              const currentVal = resources[i].attributes.identifier.value
              if (currentVal === selectedIndex) {
                const href = resources[i].attributes.href.value
                const base = resources[i].attributes['xml:base']?.value || ''
                indexLocation = base + href
                // Apply progress to the correct object in this.localStats
                const content = this.tableOfContents.filter(obj => {
                  return obj.content === selectedIndex
                })[0]
                this.selectedSCO = content.title
                break
              }
            }
          }
        } else {
          console.log('could not build table of contents')
          indexLocation = this.manifest.getElementsByTagName('resource')[0].attributes.href.value
        }
        this.$refs.scormFrame.contentWindow.location.replace(`${this.$props.training}/${indexLocation}`)
      } catch (error) {
        console.error('error', error)
        this.notFound = true
      }
      this.loading = false
    },

    /**
     * @description Finds imsmanifest file and parses it to build out all SCO content
     * @return {XMLFile} XML manifest file
     */
    async buildSources() {
      this.loading = true
      let XMLFile = null
      let manifestSchema = ''
      let schemaVersion = ''
      let noSchema = false

      try {
        const courseDir = `./${this.$props.training}/`

        const manifestFile = await axios({
          method: 'get',
          url: courseDir + 'imsmanifest.xml',
        }).then(data => {
          // console.log('data in buildSources', data)
          return data.data
        })

        // Parse manifest file to find scorm launch page (index)
        const parser = new DOMParser()
        XMLFile = parser.parseFromString(manifestFile, 'text/xml')

        this.tableOfContents = this.getContents(XMLFile)
      } catch (err) {
        console.log('error', err)
        this.notFound = true
        this.loading = false
        return
      }

      // Find explicit schema defined in the manifest
      if (XMLFile) {
        try {
          manifestSchema = XMLFile.getElementsByTagName('schema')[0].childNodes[0].nodeValue
          schemaVersion = XMLFile.getElementsByTagName('schemaversion')[0].childNodes[0].nodeValue
        } catch (err) {
          console.log('error getting schema', err)
          noSchema = true
        }
      }

      // Define expected scorm schema to use
      console.log('schema | version', manifestSchema, schemaVersion)
      if (!noSchema && manifestSchema && manifestSchema.toLowerCase() === 'adl scorm') {
        if (schemaVersion && schemaVersion.includes("2004")) {
          this.schema = '2004'
        } else if (schemaVersion && schemaVersion.includes("1.2")) {
          this.schema = '1.2'
        } else {
          this.schema = '2004' // attempt to open as 2004
        }
      } else {
        this.schema = '1.2'
      }
      this.$emit('set-schema', this.schema)

      this.loading = false
      return XMLFile
    },

    /**
     * @description
     * Parse the manifest file to determine all available sco modules
     * @param XMLFile - imsmanifest
     * @return - index location or an array of index locations
     */
    getContents(XMLFile) {
      let indexLocations = []
      const org = XMLFile.getElementsByTagName('organizations')
      let defaultOrg = ''
      if (org && org.length > 0) { // find default organization
        defaultOrg = org[0].attributes.default.value
      }
      if (defaultOrg !== '') { // Get list of items within the default organization
        const allOrgs = XMLFile.getElementsByTagName('organization')
        let targetOrg = ''
        for (let i = 0; i < allOrgs.length; i++) {
          if (allOrgs[i].attributes?.identifier && allOrgs[i].attributes.identifier.value === defaultOrg) {
            targetOrg = allOrgs[i]
          }
        }
        if (targetOrg !== '') { // Identify all sco items
          const title = targetOrg.getElementsByTagName('title')[0].childNodes[0].nodeValue
          if (title) {
            this.courseTitle = title
          }
          const orgItems = targetOrg.getElementsByTagName('item')
          const tableOfContents = this.listReferences(orgItems).filter(obj => {
            return obj.content && obj.content.length > 0
          })
          console.log('*********************** Table of contents ****', tableOfContents)
          // Build out objects to hold each available sco progress
          tableOfContents.forEach(obj => {
            if (!this.localStats[obj.title]) {
              this.localStats[obj.title] = {}
            }
          })

          indexLocations = tableOfContents
        }
      }

      return indexLocations
    },

    /**
     * @description
     * Built to be recursive, this takes all elements sent to it and attempts to drill down to child elements
     * creating an array of objects that pinpoint all references to stand-alone sco's.
     * @param XMLElements - Collection of XML Elements to drill into
     * @returns {Array} - Array of objects specifying item title and html reference
     */
    listReferences(XMLElements) {
      const content = []
      for (let i = 0; i < XMLElements.length; i++) {
        let itemTitle = XMLElements[i].getElementsByTagName('title')[0].childNodes[0].nodeValue
        let reference
        if (XMLElements[i].attributes?.identifierref) {
          reference = XMLElements[i].attributes.identifierref.value
        } else {
          reference = this.listReferences(XMLElements[i])
        }
        content.push({
          title: itemTitle,
          content: reference
        })
      }
      return content
    },

    closeOn404() {
      if (this.$props.clientActive) {
        this.$emit('post-message', 'close')
      } else {
        window.close()
      }
    },

    closeScorm() {
      console.log('local stats on closing', JSON.parse(JSON.stringify(this.localStats)))
      if (this.schema === '2004') {
        window["API_1484_11"].Terminate('user')
      } else {
        // Probably need to add moment.js to add timestamps together.
        // if (!this.localStats["cmi.core.total_time"]) {
        //   this.localStats["cmi.core.total_time"] = ""
        // }
        // this.localStats["cmi.core.total_time"] += this.localStats["cmi.core.session_time"]
        window["API"].LMSFinish('user')
      }
    },

    /**
     * @description
     * Called by the scorm file to get FLX api info
     * @param {String} key - key to search for
     * @return result - Data from the API
     */
    getLocalValues(key) {
      return this.localStats[this.selectedSCO][key] || this.deepValueSearch(key)
      // let result = this.localStats[this.selectedSCO][key] || this.deepValueSearch(key)
      // // console.log('key:', key, ' - ', result)
      // if (!result) {
      //   console.log('empty param for:', key)
      // }
      // return result
    },

    /**
     * @description If the sought value is not in localStats, dive deeper. Set defaults here.
     * @param {String} key - key to search for
     * @return result - Data to send to the SCORM
     */
    deepValueSearch(key) {
      // console.log('diving deeper for - ', key)
      switch (key) {
        case "cmi.core.student_id":
        case "cmi.learner_id":
          return this.learner.id || ''
        case "cmi.core.student_name":
        case "cmi.learner_name":
          return this.learner.name || ''
        case "cmi.core.lesson_mode":
        case "cmi.mode":
          return this.clientActive ? 'normal' : 'browse'
        case "cmi.interactions._count":
          // Trigger that quiz results are incoming
          // console.log('interactionsCount incremented')
          this.interactionsCount += 1
          // make new bucket for quiz results
          this.quizResults[this.interactionsCount] = {}
          if (this.localStats[this.selectedSCO]['cmi.success_status']) {
            // success_status reset to unknown to remove 'failed' status from 'complete-failed' type tracking
            this.localStats[this.selectedSCO]['cmi.success_status'] = 'unknown'
          }
          return this.interactionsCount.toString()
        case "cmi.comments_from_learner._count":
          this.commentsFromLearnerCount += 1
          return this.commentsFromLearnerCount.toString()
        case "cmi.comments_from_lms._count":
          this.commentsFromLmsCount += 1
          return this.commentsFromLmsCount.toString()
        case "cmi.objectives._count":
          this.objectivesCount += 1
          return this.objectivesCount.toString()
        case `cmi.interactions.${this.interactionsCount.toString()}.objectives._count`:
          this.interactionObjectivesCount += 1
          return this.interactionObjectivesCount.toString()
        case `cmi.interactions.${this.interactionsCount.toString()}.correct_responses._count`:
          this.interactionsCorrectCount += 1
          return this.interactionsCorrectCount.toString()
        case "cmi.success_status":
          return "unknown" // 'passed', 'failed', 'unknown'
        case "cmi.completion_status":
          return "unknown" // 'completed', 'incomplete', 'not attempted', 'unknown'
        default:
          return ''
      }
    },

    /**
     * @description
     * Set the local storage info based on SCORM performance
     * @param key
     * @param value
     */
    setLocalValues(key, value) {
      // console.log(`Setting ${key} to value: `, value)
      this.localStats[this.selectedSCO][key] = value

      // Flag on certain keys
      if (this.$props.clientActive) {
        switch (key) {
          case 'cmi.suspend_data':
            this.$emit('post-to-api', this.localStatus, this.localStats)
            break
          case 'cmi.completion_status': // 2004
            if (['completed'].includes(value) && this.localStats[this.selectedSCO]['cmi.success_status'] !== 'failed') {
              // console.log(`Setting ${key} to value: `, value)
              this.localStatus = 'completed'
              this.$emit('post-to-api', this.localStatus, this.localStats, 'completed')
            }
            break
            // case 'cmi.success_status': // 2004
            //   if (['passed', 'failed'].includes(value)) {
            //     console.log(`Setting ${key} to value: `, value)
            //     this.localStatus = 'completed'
            //     this.$emit('post-to-api', this.localStatus, this.localStats, 'completed')
            //   }
            //   break
          case 'cmi.core.lesson_status': // 1.2
            if (['passed', 'completed'].includes(value)) {
              // console.log(`Setting ${key} to value: `, value)
              this.localStatus = 'completed'
              this.$emit('post-to-api', this.localStatus, this.localStats, 'completed')
            }
            break
          default:
            break
        }
        // Check for quiz results and record
        if (key.match(/cmi\.interactions.*/)) {
          const name = key.replace(`cmi.interactions.${this.interactionsCount}.`, '')
          this.quizResults[this.interactionsCount][name] = value
        }
      }
      return true
    },

    /********************************
     SCORM API TRANSLATION FUNCTIONS
     ********************************/

    initialize(param) {
      console.log('Initialize: parameter=' + param);
      return 'true'
    },

    commit(param) {
      console.log("Commit parameter=" + param);
      return "true";
    },

    async terminate(param) {
      console.log("Terminate parameter=" + param);
      this.source = null
      // Make sure quiz results are recorded before closing down
      if (this.interactionsCount >= 0 && !this.$props.quizRecorded) {
        this.$emit('post-quiz-results', this.quizResults)
        return
      }
      // Dont shut down if there is an index page to return to
      if (this.tableOfContents && this.tableOfContents.length > 1 && !this.$props.externalCloseCommand) {
        this.$emit('post-to-api', this.localStatus, this.localStats)
      } else {
        if (this.clientActive && this.closeOnce) {
          this.closeOnce = false
          this.$emit('post-to-api', this.localStatus, this.localStats, 'close')
        } else {
          this.$emit('post-message', 'close')
          window.close()
        }
      }
      return "true";
    },

    getValue(param) {
      console.log("GetValue parameter=" + param);
      return this.getLocalValues(param)
    },

    setValue(param1, param2) {
      // console.log('set value called', param1, '|',  param2)
      return this.setLocalValues(param1, param2)
    },

    getErrorString(temp) {
      console.log("GetErrorString", temp);
      return "";
    },

    getDiagnostic(temp) {
      console.log("GetDiagnostic", temp);
      return "";
    },

    getLastError(temp) {
      console.log("GetLastError", temp);
      return "0";
    },

    buildScormAPIs() {
      const ctx = this

      window["API_1484_11"] = {
        Initialize: ctx.initialize,
        Commit: ctx.commit,
        Terminate: ctx.terminate,
        GetValue: ctx.getValue,
        SetValue: ctx.setValue,
        GetErrorString: ctx.getErrorString,
        GetDiagnostic: ctx.getDiagnostic,
        GetLastError: ctx.getLastError
      }

      window["API"] = {
        LMSInitialize: ctx.initialize,
        LMSCommit: ctx.commit,
        LMSFinish: ctx.terminate,
        LMSGetValue: ctx.getValue,
        LMSSetValue: ctx.setValue,
        LMSGetErrorString: ctx.getErrorString,
        LMSGetDiagnostic: ctx.getDiagnostic,
        LMSGetLastError: ctx.getLastError
      };
    },

  }
}
</script>